module.exports = __webpack_public_path__ + "img/mail.bbf86caf.svg";